"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTransactionQueryFromJsonToXml = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const convertTransactionQueryFromJsonToXml = (params) => {
    const builder = new fast_xml_parser_1.XMLBuilder({ ignoreAttributes: false });
    const input = {
        TransactionQuery: {
            Credentials: params.credentials,
            Application: params.application,
            Parameters: params.transactionQuery,
            '@_xmlns': 'https://reporting.elementexpress.com',
        },
    };
    const xml = builder.build(input);
    return xml;
};
exports.convertTransactionQueryFromJsonToXml = convertTransactionQueryFromJsonToXml;
//# sourceMappingURL=convertTransactionQueryFromJsonToXml.js.map